'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('webrtc-adapter');

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Switch = require('../Switch/Switch');

var _Switch2 = _interopRequireDefault(_Switch);

var _Uploader = require('../Uploader/Uploader');

var _Uploader2 = _interopRequireDefault(_Uploader);

var _Container = require('./components/Container');

var _Container2 = _interopRequireDefault(_Container);

var _Canvas = require('./components/Canvas');

var _Canvas2 = _interopRequireDefault(_Canvas);

var _Video = require('./components/Video');

var _Video2 = _interopRequireDefault(_Video);

var _ButtonContainer = require('./components/ButtonContainer');

var _ButtonContainer2 = _interopRequireDefault(_ButtonContainer);

var _Image = require('./components/Image');

var _Image2 = _interopRequireDefault(_Image);

var _SwitchContainer = require('./components/SwitchContainer');

var _SwitchContainer2 = _interopRequireDefault(_SwitchContainer);

var _UploadContainer = require('./components/UploadContainer');

var _UploadContainer2 = _interopRequireDefault(_UploadContainer);

var _dataUriToBlob = require('../../libs/dataUriToBlob');

var _dataUriToBlob2 = _interopRequireDefault(_dataUriToBlob);

var _blobToFile = require('../../libs/blobToFile');

var _blobToFile2 = _interopRequireDefault(_blobToFile);

var _fileToBase = require('../../libs/fileToBase64');

var _fileToBase2 = _interopRequireDefault(_fileToBase);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// Libs
// Constants


var CANVAS = 'canvas';
var VIDEO = 'video';

var Camera = function (_Component) {
  _inherits(Camera, _Component);

  function Camera() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Camera);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Camera.__proto__ || Object.getPrototypeOf(Camera)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      landscape: false,
      images: []
    }, _this.dom = {}, _this.on = false, _this.onRef = function (type) {
      return function (dom) {
        _this.dom[type] = dom;
      };
    }, _this.start = function (uploadMode) {
      if (uploadMode) return;
      var onError = _this.props.onError;
      var constraints = {
        video: {
          facingMode: 'environment'
        },
        audio: false
      };
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return onError('Camera not supported', true);
      navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
        _this.on = true;
        _this.dom[VIDEO].srcObject = stream;
      }).catch(function (error) {
        _this.on = false;
        onError(error, false);
      });
    }, _this.stop = function () {
      if (!_this.on) return;
      _this.on = false;
      if (!_this.dom || !_this.dom[VIDEO]) return;

      _this.dom[VIDEO].srcObject.getVideoTracks().forEach(function (track) {
        return track.stop();
      });
    }, _this.takePicture = function () {
      if (!_this.on) return;
      _this.dom[CANVAS].width = _this.dom[VIDEO].videoWidth;
      _this.dom[CANVAS].height = _this.dom[VIDEO].videoHeight;

      _this.dom[CANVAS].getContext('2d').drawImage(_this.dom[VIDEO], 0, 0);

      var uri = _this.dom[CANVAS].toDataURL('image/png');

      var blob = (0, _dataUriToBlob2.default)(uri);
      var file = (0, _blobToFile2.default)(blob, 'cameraImage.png', 'image/png');

      _this.props.onImage({
        file: file,
        uri: uri
      });

      _this.setState({
        images: [].concat(_toConsumableArray(_this.state.images), [uri])
      });
    }, _this.removePicture = function (img) {
      return _this.setState({
        images: [].concat(_toConsumableArray(_this.state.images)).filter(function (i) {
          return i !== img;
        })
      });
    }, _this.changeUploadMode = function () {
      if (!_this.props.on) return;
      var uploadMode = !_this.props.uploadMode;
      if (!uploadMode) _this.start(uploadMode);else _this.stop();

      _this.props.onUploadMode(uploadMode);
    }, _this.acceptFile = function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          file = _ref3[0];

      (0, _fileToBase2.default)(file).then(function (uri) {
        _this.props.onImage({
          file: file,
          uri: uri
        });

        _this.setState({
          images: [].concat(_toConsumableArray(_this.state.images), [uri])
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Camera, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.on && this.props.on) this.start(this.props.uploadMode);else if (prevProps.on && !this.props.on) this.stop();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          landscape = _props.landscape,
          uploadMode = _props.uploadMode,
          onUploadMode = _props.onUploadMode,
          fixed = _props.fixed;
      var images = this.state.images;
      return _react2.default.createElement(_Container2.default, null, uploadMode ? _react2.default.createElement(_UploadContainer2.default, {
        fixed: fixed,
        landscape: landscape
      }, _react2.default.createElement(_Uploader2.default, {
        onChange: this.acceptFile,
        small: true
      })) : [_react2.default.createElement(_Canvas2.default, {
        key: 'canvas',
        innerRef: this.onRef(CANVAS)
      }), _react2.default.createElement(_Video2.default, {
        key: 'camera',
        innerRef: this.onRef(VIDEO),
        autoPlay: true,
        playsInline: true
      })], images.map(function (img) {
        return _react2.default.createElement(_Image2.default, {
          key: img,
          src: img,
          onRemove: _this2.removePicture
        });
      }), !!onUploadMode && _react2.default.createElement(_SwitchContainer2.default, null, _react2.default.createElement(_Switch2.default, {
        value: uploadMode,
        onChange: this.changeUploadMode,
        size: 'small'
      })), _react2.default.createElement(_ButtonContainer2.default, {
        landscape: landscape,
        fixed: fixed
      }, _react2.default.createElement(_Button2.default, {
        size: 'giant',
        theme: 'grey',
        icon: 'camera',
        onClick: this.takePicture,
        shadow: true
      })));
    }
  }]);

  return Camera;
}(_react.Component);

Camera.propTypes = {
  on: _propTypes2.default.bool.isRequired,
  landscape: _propTypes2.default.bool,
  uploadMode: _propTypes2.default.bool,
  fixed: _propTypes2.default.bool,
  onImage: _propTypes2.default.func.isRequired,
  onError: _propTypes2.default.func.isRequired,
  onUploadMode: _propTypes2.default.func
};
Camera.defaultProps = {
  fixed: false,
  uploadMode: false
};
exports.default = Camera;